import React from 'react'
import { SpinningButton } from '../spinning-button'
import symbolOneSrc from './assets/symbol-one.png'
import symbolTwoSrc from './assets/symbol-two.png'
import './styles.scss'

const MenuPanel = () => {
  return (
    <div className="menu-panel px-sm-2 px-md-0">
      <SpinningButton
        link
        src={symbolOneSrc}
        target="_blank"
        href="https://soundcloud.com/slayanne"
        className={'menu-panel-left-button'}
        title="soundcloud"
      />
      <SpinningButton
        link
        src={symbolTwoSrc}
        target="_blank"
        href="https://www.youtube.com/channel/UC5N2EI37-g4rCOg2LUljGiA"
        title="youtube"
        className={'menu-panel-right-button'}
      />
    </div>
  )
}

export default MenuPanel
